export const getDisplayProfessionalName = (professional,hasDrPrefix,isTitle=true)=>{
  let displayProfName = professional?.first_name + " " +professional?.last_name
  if(hasDrPrefix){
    displayProfName = "Dr. "+ displayProfName
  }
   if(professional?.title && isTitle){
    displayProfName = `${displayProfName}, ${professional?.title}`
  }
  return displayProfName
}